import React, {useLayoutEffect} from "react";
import BuildIcon from "@material-ui/icons/Build";
import {blue} from "@material-ui/core/colors";
import RichText from "view/components/RichText";
import {useMaintenanceModeStore} from "store/general/maintenanceMode.store";
import useElementSizeListener from "hooks/ui/useElementSizeListener";
import {useLocalisedLanguageCode} from "hooks/translation";
import useStyles from "./styles";

function MaintenanceModePanel() {
  const [rootRef, size] = useElementSizeListener<HTMLDivElement>();
  const {
    shouldShowMaintenanceModeNotification,
    maintenanceMode,
    updatePanelHeight,
  } = useMaintenanceModeStore();

  useLayoutEffect(() => {
    updatePanelHeight(size.height);
  }, [size.height, updatePanelHeight]);

  const classes = useStyles();

  const languageCode = useLocalisedLanguageCode(true);
  const description =
    maintenanceMode.descriptionTranslations?.[languageCode] ||
    maintenanceMode.description;

  return (
    <div
      style={{
        display: shouldShowMaintenanceModeNotification() ? "flex" : "none",
      }}
      ref={rootRef}
      className={classes.maintenanceRoot}
    >
      <BuildIcon
        className={classes.maintenanceModeIcon}
        htmlColor={blue.A400}
      />
      <RichText className={classes.maintenanceModeText} content={description} />
    </div>
  );
}

export default MaintenanceModePanel;
